import 'react-toggle/style.css';
import './ToggleSwitch.scss';

import React from 'react';
import Toggle from 'react-toggle';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from 'components/Label';

export default class ToggleSwitch extends React.Component {
    static propTypes = {
        checked: PropTypes.bool.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        label: PropTypes.string.isRequired,
        labelPosition: PropTypes.string,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired
    };

    render() {
        let { label, labelPosition, ...otherProps } = this.props;
        return (
            <div className={classNames(
                'c-toggle-switch',
                {
                    'a-toggle-switch--left-label': labelPosition === 'left',
                    'a-toggle-switch--top-label': labelPosition === 'top'
                }
            )}>
                <Label isWrappingLabel={true}>
                    <Toggle
                        {...otherProps}
                        icons={{
                            checked: null,
                            unchecked: null
                        }}
                    />
                    <span>{label}</span>
                </Label>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ToggleSwitch/index.js